import * as React from 'react';
import { SystemIconType } from '../types';
/**
 * @deprecated Please use @fiverr-private/visuals package.
 */
const CategoryWebDevelopmentLargeIcon = ({
    size = 24,
    color = 'currentFill'
}: SystemIconType) => (
    <svg width={size}
        height={size}
        viewBox="0 0 33 32"
        fill={color}
        xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#category_web_development_large_icon_svg__a)"
            stroke="#404145"
            strokeWidth={1.5}
            strokeMiterlimit={10}
            strokeLinecap="square">
            <path d="M16.332 30.667v-5.334M8.332 30.667h16M28.333 25.333h-24a2.666 2.666 0 0 1-2.667-2.666V4a2.666 2.666 0 0 1 2.667-2.667h24A2.666 2.666 0 0 1 30.999 4v18.667a2.666 2.666 0 0 1-2.666 2.666ZM1.666 20h29.333"/>
        </g>
        <path d="m10.999 8-2.667 2.667 2.667 2.666M21.666 8l2.667 2.667-2.667 2.666M14.998 16l2.667-10.667"
            stroke="#404145"
            strokeWidth={1.5}
            strokeMiterlimit={10}
            strokeLinecap="square"/>
        <defs>
            <clipPath id="category_web_development_large_icon_svg__a">
                <path fill="#fff"
                    transform="translate(.332)"
                    d="M0 0h32v32H0z"/>
            </clipPath>
        </defs>
    </svg>
);
CategoryWebDevelopmentLargeIcon.displayName = 'CategoryWebDevelopmentLargeIcon';
export default CategoryWebDevelopmentLargeIcon;
